export default "__VITE_ASSET__Cl2ZaA3l__"